import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import dataPipelinePng2x from './assets/DataPipeline@2x.png'
import dataPipelineWebp from './assets/DataPipeline.webp'
import dataPipelineWebp2x from './assets/DataPipeline@2x.webp'
import dataPipelineWebp3x from './assets/DataPipeline@3x.webp'

const copy = {
  heading: `Your fully managed data pipeline`,
  description: `Use Segment to capture every interaction users have with your app across iOS, Android, push, email, help
desks, and more. We’ll get your data where you need it, so you can focus on analyzing behavior and building
personalized campaigns.`,
}

const PipelineHeader = () => {
  return (
    <StyledSection variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <picture>
          <source
            type="image/webp"
            srcSet={`${dataPipelineWebp}, ${dataPipelineWebp2x} 2x, ${dataPipelineWebp3x} 3x`}
          />
          <StyledImage
            src={dataPipelinePng2x}
            alt="Illustration: Activate anywhere"
            width="1572"
            height="730"
            loading="lazy"
          />
        </picture>
      </Section.Contents>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      gap: 40px;
    }
  }
`

const StyledImage = styled(Image)`
  max-width: 1040px;
  margin: 0 auto;
  position: relative;
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default PipelineHeader
